// extracted by mini-css-extract-plugin
export var smallSpinner = "_rm-0";